// src/utils/supportSignOut.js
// 3.65.2 (owner): signing out of the portal (by hand, after an hour without
// use, or any other way) signs this browser out of the support site too, so
// the next person can't open support.crazypixels.org as the last one. The
// site's Crazy Pixels portal sign-in plugin ends its session on ?cp_logout=1.
// keepalive: it still goes when the page reloads straight after sign-out.
export function supportSignOut() {
  try {
    fetch('https://support.crazypixels.org/ticket/?cp_logout=1', { method: 'GET', mode: 'no-cors', credentials: 'include', keepalive: true, cache: 'no-store' }).catch(() => {});
  } catch { /* the support site is optional */ }
}
